import { request } from '@umijs/max'
import type { RequestOptions } from 'umi'

export type IRequestOptions = RequestOptions & Partial<{ isFormUrlencoded: boolean; isFormData: boolean }>
export interface IRequestOptionsWithPass extends RequestOptions {
	passResponseHandler: true
}

export interface IRequest {
	<T = any>(url: string, opts: IRequestOptionsWithPass): Promise<T>
	<T extends { msg: any }>(url: string, opts: RequestOptions): Promise<T['msg']> // getResponse 默认是 false， 因此不提供该参数时，只返回 data
}

const net: IRequest = async (url: string, opts: IRequestOptionsWithPass | RequestOptions) => {
	const result = await request(url, opts)
	if (opts.passResponseHandler) return result
	return result.msg
}
export default net
